var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browserMask",on:{"click":_vm.close}},[(_vm.imgUrl)?_c('img',{staticClass:"type",attrs:{"src":_vm.imgUrl}}):_vm._e(),_c('i'),_c('img',{staticClass:"header",attrs:{"src":_vm.header,"alt":""}}),_c('img',{staticClass:"footer",attrs:{"src":_vm.footer,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }